<template>
    <div id="page">
        <div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1><i class="fa fa-arrow-left back-button"></i>Imagenes OT {{ idcotizacionvehiculo }}</h1>
            <a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
        </div>

        <div class="content-boxed bg-gray1-dark">
            <!-- Mostrar fotos capturadas -->
            <div v-if="Object.keys(photos).length" style="margin-top: 20px;">
                <h3 style="color: black;"> Imagenes Capturadas:</h3>
                <div id="divFotosCapturada" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;">
                    <div id="divLado" v-for="(photo, angle) in photos" :key="angle"
                        style="display: flex; flex-direction: column; align-items: center; border: 1px solid #ccc; border-radius: 10px; overflow: hidden;">
                        <div style="display: flex; justify-content: center; width: 100%; padding: 10px;">
                            <img :src="photo" :alt="'Foto del vehículo (' + angle + ')'"
                                style="width: 100%; height: 150px; object-fit: cover; cursor: pointer; border-radius: 8px;"
                                @click="selectPhoto(photo, angle, 'angle')" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="Object.keys(photosExtras).length" style="margin-top: 20px;">
                <h3 style="color: black;">Imagenes Adicionales:</h3>
                <div id="divFotosCapturadaExtras"
                    style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;">
                    <div id="divLado" v-for="(photo, angle) in photosExtras" :key="angle"
                        style="display: flex; flex-direction: column; align-items: center; border: 1px solid #ccc; border-radius: 10px; overflow: hidden;">
                        <div style="display: flex; justify-content: center; width: 100%; padding: 10px; cursor: pointer;"
                            @click="selectPhoto(photo, angle, 'extra')">
                            <!-- Cambia la imagen por un icono -->
                            <img :src="photo" :alt="'Foto del vehículo (' + angle + ')'"
                                style="width: 100%; height: 150px; object-fit: cover; cursor: pointer; border-radius: 8px;"
                                @click="selectPhoto(photo, angle, 'angle')" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showEdit" ref="editDiv" style="margin-top: 20px; margin-bottom: 80px;">
                <h3 style="color: black;"> Imagen</h3>
                <div style="display: flex; justify-content: center; margin-bottom: 10px;">
                    <!-- Cambia los valores de width y height aquí -->
                    <canvas ref="canvas" width="800" height="600"
                        style="width: 90%; height: auto; border: 1px solid black;"></canvas>
                    <img :src="selectedPhoto" alt="Foto seleccionada" style="display:none;" ref="hiddenImage" 
                        @load="drawOnCanvas" />
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import * as db from "./../../database.js";
import * as validate from "./../../validate.js";


export default {
    data(){
        return{
            idcotizacionvehiculo: 0,
            selectedPhoto: '',
            showEdit: false,
            photos: {},
            photosExtras: {},
            PhotoSelected: null
        }
    },

    created() {
        this.userimageurl = "background-image:url(" + db.getServerHTTP() + JSON.parse(localStorage.getItem('user')).imageurl + ")"
        this.idcotizacionvehiculo = localStorage.getItem('idcotizacionvehiculo');

        const strParams = JSON.stringify({ idcotizacionvehiculo: this.idcotizacionvehiculo });

        db.getFx2("ot.getImagenesOTVehiculo", strParams)
        .then(result => {
            if (result && result.data) {
                if (result.data.err) {
                    // alert(result.data.err);
                    console.log(result.data.err);
                } else {
                    // Inicializar los objetos
                    const photos = {};
                    const photosExtras = {};

                    // Iterar sobre las imágenes obtenidas
                    for (let ImagenAngulo of result.data.images) {
                        if (ImagenAngulo.angle) {
                            // Asignar las imágenes a objetos con claves basadas en el ángulo
                            if (!ImagenAngulo.angle.includes("Adicional")) {
                                photos[ImagenAngulo.angle] = ImagenAngulo.url;
                            } else {
                                photosExtras[ImagenAngulo.angle] = ImagenAngulo.url;
                            }
                        }
                    }

                    this.photos = photos;
                    this.photosExtras = photosExtras;
                }
            } else {
                console.error("Error en la respuesta del servidor", result);
            }
        })
        .catch(error => {
            console.error("Error al obtener imágenes:", error);
            alert("Ocurrió un error al obtener las imágenes.");
        });
    },

    methods:{
        selectPhoto(photo, key, type) {

            const photoCollection = type === 'angle' ? this.photos : this.photosExtras;
            const currentViewProperty = type === 'angle' ? 'currentView' : 'currentExtraView';

            if (photoCollection.hasOwnProperty(key)) {
                this.selectedPhoto = photo;
                this.showEdit = true; // Mostrar el editor

                this[currentViewProperty] = key;

                // Desplazarse al div de edición
                this.$nextTick(() => {
                    const editDiv = this.$refs.editDiv;
                    if (editDiv) {
                        editDiv.scrollIntoView({ behavior: 'smooth' });
                    }
                });

                this.PhotoSelected = key;
            }
        },
        drawOnCanvas() {
            const canvas = this.$refs.canvas;
            this.context = canvas.getContext('2d');
            const img = this.$refs.hiddenImage;

            // Dibuja la imagen sobre el canvas al cargarla
            this.context.drawImage(img, 0, 0, canvas.width, canvas.height);
        }
    }
}
</script>